import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XpoLtlBaseCacheService } from '@xpo-ltl/ngx-ltl';
import { ClaimsApiService, ListExaminerRebuttalsResp, ListExaminerRebuttalsQuery } from '@xpo-ltl-2.0/sdk-claims';
import * as _ from 'lodash';
import { AssignedRebuttalsCacheParams } from '../../interfaces/assigned-rebuttals-cache-params.interface';
import { ApiRequest } from '@xpo-ltl/data-api';
import { ListInfo } from '@xpo-ltl/sdk-common';

@Injectable()
export class ListExaminerRebuttalsCacheService extends XpoLtlBaseCacheService<AssignedRebuttalsCacheParams, ListExaminerRebuttalsResp> {
  constructor(private claimsApiService: ClaimsApiService) {
    super();
  }

  protected getKeyFromParams(params: AssignedRebuttalsCacheParams): string {
    return `${params.index}`;
  }

  protected requestData(params: AssignedRebuttalsCacheParams): Observable<ListExaminerRebuttalsResp> {
    const request = new ListExaminerRebuttalsQuery();
    _.assign(request, _.pick(params, _.keys(request)));
    request.examinerEmployeeId = params.employeeId;
    request.listInfo = new ListInfo();
    request.listInfo.startAt = params.startAt;
    request.listInfo.numberOfRows = params.numberOfRows;
    request.filterByUpdatesInd = params.filterByUpdatesInd; 
    request.rebuttalInternalStatusCd = params.rebuttalInternalStatusCd;
    request.listInfo.sortFields = [{sortByFieldName: params.sortByFieldName.toString(), sortOrder: params.sortOrder.toString()}];

    return this.claimsApiService.listExaminerRebuttals(request, { ...ApiRequest.defaultDataOptions, toastOnError: false });
  }
}
